export default "__VITE_ASSET__CRiaCSf0__"